import { createFileRoute } from "@tanstack/react-router";

import ManageZones from "@/components/ManageZones";

export const Route = createFileRoute("/gym/$venueUuid/settings/zones")({
  component: () => <ManageZones climbType="BOULDER" />,
  beforeLoad: () => {
    return {
      // Not all gyms have zones, so just redirect to main settings page
      switchVenueLinkOpts: {
        path: "/gym/$venueUuid/settings",
      },
    };
  },
});
